/***************************************************************
Hawaiian Macadamia Nut Services
12/05/2018
Alexander Self
Mech harvest modal
- Summary of mech. harvest log to be submitted; along with recently submitted logs
***************************************************************/
import MechHarvestTable from '../mechHarvest_table';
import React from 'react';
const $ = window.$;


const MechHarvestDeleteModal = ({ id, selectedField, selectedHarvest, onClick }) => {
  $(document).ready(() => {
    $(`#${id}`).modal();
  });

  return (
    <div id={id} className="modal modal-fixed-footer">
      <div className="modal-content">
        <h4>Delete Mechanical Harvest Log</h4> <hr />
        <div className="row">
          <blockquote><b className="day-off">Do you wish to delete the following log?</b></blockquote>
          <MechHarvestTable harvest={[selectedHarvest]} field={selectedField} totals={false} />
        </div>
      </div>
      <div className="modal-footer">
        <button type="button" className="modal-action modal-close waves-effect btn-flat">Cancel</button>
        <button className="modal-action modal-close waves-effect waves-red btn red"
          id="mech-harvest-delete-btn"
          onClick={() => onClick(selectedHarvest)}>
          Submit
        </button>
        </div>
    </div>
  );
};

export default MechHarvestDeleteModal;



// WEBPACK FOOTER //
// ./src/components/harvest/manage/mechHarvest_delete_modal.jsx